<script>
import { resetObject, setObject } from "../../common/util";
export default {
    created() {},
    props: {
        title: {
            type: String,
            required: true
        },
        dialogWidth: {
            type: String,
            default: () => "50%"
        },
        codeEvent: {
            type: Function
        },
        searchEvent: {
            type: Function
        },
        codeDetail: {
            type: Object
        },
        editOption: {
            type: Object
        }
    },
    data() {
        return {
            codeQuery: {
                name: "",
                code: "",
                shortCode: ""
            }
        };
    },
    methods: {
        initQuery(row) {
            const type = this.editOption.type;
            Object.is(type, 0) && setObject(this.editQuery, row);
        },
        async submit() {
            const params = this.editOption.row
                ? { ...this.codeQuery, id: this.codeDetail.row.id }
                : this.codeQuery;
            const { status } = await this.codeEvent(params);
            if (Object.is(status, 0)) {
                this.searchEvent();
                this.$message.success(`${this.title}成功`);
            }
            this.editOption.dialog = false;
            resetObject(this.codeQuery);
        }
    },
    mounted() {},
    computed: {},
    watch: {}
};
</script>
<template>
    <div class="edit">
        <el-dialog
            v-if="editOption.type === 0"
            :title="title"
            :width="dialogWidth"
            :visible.sync="editOption.dialog"
            :modal-append-to-body="false"
            :close-on-click-modal="false"
        >
            <el-form :model="codeQuery" ref="information">
                <el-form-item label="字段代号" label-width="100px">
                    <el-input v-model="codeQuery.code"></el-input>
                </el-form-item>
                <el-form-item label="字段简写" label-width="100px">
                    <el-input v-model="codeQuery.shortCode"></el-input>
                </el-form-item>
                <el-form-item label="字段名称" label-width="100px">
                    <el-input v-model="codeQuery.name"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="editOption.dialog = false" size="small"
                    >取消</el-button
                >
                <el-button type="success" @click="submit" size="small"
                    >提交</el-button
                >
            </div>
        </el-dialog>
        <el-dialog
            v-if="editOption.type === 1"
            title="编辑"
            :width="dialogWidth"
            :visible.sync="editOption.dialog"
            :modal-append-to-body="false"
            :close-on-click-modal="false"
        >
            <el-form :model="codeQuery" ref="information">
                <el-form-item label="字段代号" label-width="100px">
                    <el-input v-model="codeQuery.code"></el-input>
                </el-form-item>
                <el-form-item label="字段简写" label-width="100px">
                    <el-input v-model="codeQuery.shortCode"></el-input>
                </el-form-item>
                <el-form-item label="字段名称" label-width="100px">
                    <el-input v-model="codeQuery.name"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="editOption.dialog = false" size="small"
                    >取消</el-button
                >
                <el-button type="success" @click="submit" size="small"
                    >提交</el-button
                >
            </div>
        </el-dialog>
    </div>
</template>
<style scoped lang="stylus">
.el-input
    width 90%
</style>
